import React, { Component } from 'react'
import { participants } from 'constants/wizards'
import { meta } from 'helpers/decorators'
import { Wizard } from 'components/masters'
import { WizardProgress } from 'components/layout'
import { renderRoutes } from 'react-router-config'

@meta({
  title: 'Register participant'
})
class Participant extends Component {
  render() {
    const { route } = this.props
    const children = route && renderRoutes(route.routes)

    return (
      <Wizard
        items={participants}
        wizardProgress={<WizardProgress {...this.props} />}
        {...this.props}
      >
        {children}
      </Wizard>
    )
  }
}

export default Participant
